module.exports = __webpack_public_path__ + "static/media/cloud-weather-storage-svgrepo-com.8bfdcf44.svg";